import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { toast } from '@grandvisionhq/common';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import { GET_STORE_BY_ID } from '../../operations/queries/get-store-by-id.js';
import '../../types.js';
import fromStoreByByIdQueryToStoreById from './adapters/fromStoreByByIdQueryToStoreById.js';

const useStoreById = (variables)=>{
    const { locale  } = useIntl();
    const [query, queryState] = useLazyQuery(GET_STORE_BY_ID, {
        variables,
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        },
        errorPolicy: 'all',
        onError (error) {
            toast.failed('stores.page.search.getStoreById.error');
            console.error('Failed to fetch store by code: ', error);
        }
    });
    var _data;
    const { store  } = (_data = queryState.data) !== null && _data !== void 0 ? _data : {};
    const data = React.useMemo(()=>fromStoreByByIdQueryToStoreById(store)
    , [
        store
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            })
        ]
    , [
        data,
        queryState,
        query
    ]);
};

export { useStoreById as default };
//# sourceMappingURL=use-store-by-id.js.map
